import { ExtractPropTypes } from 'vue';
import defaults, { Options } from './options';
import CurrencyNumber from './CurrencyNumber';
import {
  addThousandSeparator,
  fixed,
  isValidFloat,
  joinIntegerAndDecimal,
  numbersToCurrency,
  onlyNumbers,
  round,
} from './Utils';

export default function format(
  input: string | number | null | undefined,
  opt: Options | ExtractPropTypes<never> = defaults,
): string {
  if (input === null || input === undefined) {
    input = '';
  } else if (typeof input === 'number') {
    input = input.toFixed(fixed(opt.precision) + 1).slice(0, -1);
  } else if (!opt.disableNegative && input === '-') {
    return input;
  }

  const negative = opt.disableNegative ? '' : (input.indexOf('-') >= 0 ? '-' : '');

  let filtered = input.replace(opt.prefix, '');

  if (!opt.precision && isValidFloat(filtered)) {
    filtered = round(filtered, 0);
  }

  const numbers = onlyNumbers(filtered);
  const bigNumber = new CurrencyNumber(negative + numbersToCurrency(numbers, opt.precision));

  // min and max must be a valid float or integer
  if (opt.max) {
    if (bigNumber > opt.max) {
      bigNumber.setNumber(opt.max);
    }
  }
  if (opt.min) {
    if (bigNumber < opt.min) {
      bigNumber.setNumber(opt.min);
    }
  }

  const currency = bigNumber.toFixed(fixed(opt.precision));
  // test if it is zero 0, or 0.0 or 0.00 and so on...
  if ((/^0(\.0+)?$/g).test(currency) && opt.allowBlank) {
    return '';
  }

  // eslint-disable-next-line prefer-const
  let [integer, decimal] = currency.split('.');

  const decimalLength = decimal !== undefined ? decimal.length : 0;

  integer = integer.padStart(opt.minimumNumberOfCharacters - decimalLength, '0');

  integer = addThousandSeparator(integer, ",");

  const output = opt.prefix
    + joinIntegerAndDecimal(integer, decimal, ".");
  return output;
}
